import React from 'react';
var CollapseContext = /*#__PURE__*/React.createContext({
  collapsedFirstElement: false,
  collapsedLastElement: false,
  toggleFirstElement: function toggleFirstElement() {
    throw new Error('Cannot call toggleFirstElement outside of ResizableElements');
  },
  toggleLastElement: function toggleLastElement() {
    throw new Error('Cannot call toggleLastElement outside of ResizableElements');
  }
});
export default CollapseContext;